import React, { Component } from 'react';

export default class Login extends Component
{
    render()
    {
        return <h1>Login form</h1>;
    }
} 